import PropTypes from "prop-types";
import React from "react";
import Modal from "react-modal";
import { connect } from "react-redux";

import AccessDenied from "../../base/containers/AccessDenied";
import DeletePolicies from "../../listview/containers/DeletePolicies";
import servicesSelectors from "../../policies/selectors/services";

// Set for accessibility so that modals are rendered fullscreen
// for screenreaders.
Modal.setAppElement("#app");

const MODAL_COMPONENTS = {
  DELETE_POLICIES: DeletePolicies,
  ACCESS_DENIED: AccessDenied
};

class ModalRoot extends React.Component {
  state = {
    isOpen: false
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps !== this.props) {
      this.setState({
        isOpen: nextProps.modalProps.open
      });
    }
  }

  closeModal = () => {
    this.setState({ isOpen: false });
  };

  render() {
    const { hasServices, modalType, modalProps } = this.props;
    if (!modalType) {
      return null;
    }

    const SpecificModal = MODAL_COMPONENTS[modalType];
    const { isOpen } = this.state;
    return (
      <Modal
        shouldCloseOnOverlayClick={hasServices}
        className="p-modal__dialog"
        overlayClassName="p-modal"
        isOpen={isOpen}
        onRequestClose={this.closeModal}
      >
        <SpecificModal {...modalProps} />
      </Modal>
    );
  }
}

ModalRoot.propTypes = {
  hasServices: PropTypes.bool.isRequired,
  modalProps: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  modalType: PropTypes.string
};

ModalRoot.defaultProps = {
  modalType: null
};

const mapStateToProps = state => ({
  ...state.modal,
  hasServices: servicesSelectors.getFiltered(state).length !== 0
});

export default connect(mapStateToProps)(ModalRoot);
